import { render, staticRenderFns } from "./CompanyGeneral.vue?vue&type=template&id=51bc72a3&scoped=true&"
import script from "./CompanyGeneral.vue?vue&type=script&lang=js&"
export * from "./CompanyGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc72a3",
  null
  
)

export default component.exports